@if (isOpen) {
<div class="fixed inset-0 bg-[var(--color-gray-900)]/30 flex items-center justify-center z-[99999]"
  (click)="closeModal()">
  <div [ngClass]="
        isSmallScreen()
          ? 'bg-[var(--color-white)] w-full h-full flex flex-col dark:bg-[var(--color-dark-bg-secondary)]'
          : 'bg-[var(--color-white)] rounded-2xl w-full h-5/6 max-h-[625px] min-h-[625px] max-w-[680px] shadow-sm flex flex-col dark:bg-[var(--color-dark-bg-secondary)]'
      " (click)="$event.stopPropagation()">
    <div [ngClass]="
          isSmallScreen()
            ? 'flex items-center justify-between p-4 border-b border-[var(--color-gray-200)] dark:bg-[var(--color-dark-bg-secondary)] dark:border-[var(--color-white)]/15 rounded-t-2xl'
            : 'flex items-center justify-between p-6 border-b border-[var(--color-gray-200)] dark:bg-[var(--color-dark-bg-secondary)] dark:border-[var(--color-white)]/15 rounded-t-2xl'
        ">
      <input #searchInput type="text" id="searchChats" name="searchChats" placeholder="Buscar chats"
        autocomplete="false"
        class="w-full outline-none placeholder-[var(--color-gray-500)] dark:placeholder-[var(--color-gray-400)] dark:text-[var(--color-white)] dark:caret-[var(--color-white)]"
        (input)="onSearchInput($event)" />
      <button (click)="closeModal()" class="text-[var(--color-gray-500)] cursor-pointer dark:text-[var(--color-white)]">
        <fa-icon [icon]="faXmark" class="text-xl"></fa-icon>
      </button>
    </div>
    <div class="overflow-y-auto flex-1 p-4">
      @if (searchTerm ? isLoading : (isLoading || isLoadingInitial)) {
      <div class="flex justify-center items-center h-20">
        <app-loader label="Cargando chats..." size="sm"></app-loader>
      </div>
      } @else if (searchTerm && searchResults.length === 0) {
      <div class="text-[var(--color-neutral-600)] text-center py-8 dark:text-[var(--color-neutral-400)]">
        No se encontraron resultados para "{{ searchTerm }}"
      </div>
      } @else if (searchTerm && searchResults.length > 0) {
      <div class="space-y-1">
        @for (chat of searchResults; track chat.chat_id) {
        <div
          class="p-3 hover:bg-[var(--color-brand-200)] rounded-lg cursor-pointer transition-colors dark:hover:bg-[var(--color-white)]/10 flex items-start gap-3"
          (click)="selectChat(chat)">
          <fa-icon [icon]="getParsedIcon(chat)"
            class="text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] text-sm flex-shrink-0 mt-0.5"></fa-icon>
          <div class="flex-1 min-w-0">
            <p class="text-md text-[var(--color-gray-800)] line-clamp-1 dark:text-[var(--color-white)]">
              {{ getChatTitle(chat) }}
            </p>
          </div>
          @if (isChatProcessing(chat)) {
          <div
            class="flex items-center gap-1 px-2 py-0.5 mr-5 rounded-full bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700">
            <span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse flex-shrink-0"></span>
          </div>
          }
        </div>
        }
      </div>
      } @else {
      <div class="space-y-4">
        @if (todayChats.length > 0) {
        <div>
          <h3 class="text-sm text-[var(--color-gray-600)] mb-2 dark:text-[var(--color-gray-400)]">Hoy</h3>
          <div class="space-y-2">
            @for (chat of todayChats; track chat.chat_id) {
            <div
              class="p-3 hover:bg-[var(--color-brand-200)] rounded-lg cursor-pointer transition-colors dark:hover:bg-[var(--color-white)]/10 flex items-center gap-3"
              (click)="selectChat(chat)">
              <fa-icon [icon]="chat.parsedIcon"
                class="text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] text-sm flex-shrink-0"></fa-icon>
              <p class="text-md text-[var(--color-gray-800)] line-clamp-1 dark:text-[var(--color-white)] flex-1">
                {{ getChatTitle(chat) }}
              </p>
              @if (isChatProcessing(chat)) {
              <div
                class="flex items-center gap-1 px-2 py-0.5 mr-5 rounded-full bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700">
                <span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse flex-shrink-0"></span>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }

        @if (yesterdayChats.length > 0) {
        <div>
          <h3 class="text-sm text-[var(--color-gray-600)] mb-2 dark:text-[var(--color-gray-400)]">Ayer</h3>
          <div class="space-y-2">
            @for (chat of yesterdayChats; track chat.chat_id) {
            <div
              class="p-3 hover:bg-[var(--color-brand-200)] rounded-lg cursor-pointer transition-colors dark:hover:bg-[var(--color-white)]/10 flex items-center gap-3"
              (click)="selectChat(chat)">
              <fa-icon [icon]="chat.parsedIcon"
                class="text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] text-sm flex-shrink-0"></fa-icon>
              <p class="text-md text-[var(--color-gray-800)] line-clamp-1 dark:text-[var(--color-white)] flex-1">
                {{ getChatTitle(chat) }}
              </p>
              @if (isChatProcessing(chat)) {
              <div
                class="flex items-center gap-1 px-2 py-0.5 mr-5 rounded-full bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700">
                <span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse flex-shrink-0"></span>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }

        @if (todayChats.length === 0 && yesterdayChats.length === 0) {
        <div class="text-[var(--color-neutral-600)] text-center py-8 dark:text-[var(--color-neutral-400)]">
          No hay chats recientes
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>
}
